export default {
  grays: {
    gray1: '#161618',
    gray2: '#2A2B2F',
    gray25: '#25262B',
    gray275: '#32343C',
    gray285: '#383A3E',
    gray3: '#8e8e8e',
    gray4: '#bababa',
    gray5: '#dedede',
    gray6: '#eaeaea',
    gray7: '#676767',
    gray8: '#A1A5B4',
    gray85: '#d9d9d9',
    gray9: '#f4f4f4',
    gray10: '#F1F2F5',
    gray12: '#EFF0F3',
  },
  blacks: {
    black0: '#010101',
  },
  white: '#FFFFFF',
  black: '#111111',
  reds: {
    red1: '#E51F37',
    red2: '#C1172C',
    red3: '#ed0a0f',
  },
  green: {
    green1: '#a2d76b',
    green2: '#4D5E3A',
    green3: '#536449',
    green4: '#E3F3D3',
    green5: '#068C63',
  },
  yellow: {
    yellow1: '#2A2723',
    yellow2: '#FFB186',
  },
};
